<template>
  <div class="thank_you_block" v-if="show">
    <div class="icon">
      <img src="@/assets/img/check-circle-green.svg" />
    </div>
    <p class="text">Your request was successfully sent! Thank you!</p>
  </div>
</template>

<script>
export default {
  name: 'thank-you',

  props: [
    'show'
  ],

  mounted() {
    this.timedClose()
  },

  methods: {
    timedClose() {
      setTimeout(() => {
        this.$emit('close')
      }, 2000)
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/home.sass"
</style>